$.extend($.validator.messages, {
    max: $.validator.format("Prašau įvesti mažesnę reikšmę arba lygią {0}."),
    min: $.validator.format("Prašau įvesti didesnę reikšmę arba lygią {0}.")
});

$.validator.setDefaults({
    errorClass: "is-invalid",
    validClass: "is-valid",
    rules: {
        xdate: {
            xdate: true
        },
        phonecheck: {
            onkeyup: false
        }
    },
    ignore: ":disabled",
    highlight: function (element, errorClass, validClass) {
        var el = $(element);

        if (el.is(":hidden")) {
            if (el.closest(".tab-pane").length) {
                // Yra tabai
                var id = el.closest(".tab-pane").attr("id");

                $('[href="#' + id + '"], [data-target="#' + id + '"]').tab("show");
            } else if (el.closest(".collapse").length) {
                el.closest(".collapse").collapse("show");
            } else if (el.data('type') == "xfile") {
                el.closest('.xfileinput').find('.xfileinput-upload-filename').addClass(errorClass);
            } else {
                console.log("Nematomas privalomas laukas: " + el.attr("name"));
            }
        }
        el.addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
        var el = $(element);
        el.removeClass(errorClass);
        el.next(".feedback").remove();
    },
    errorPlacement: function (error, element) {
        // Select2 plugin'as (seni sprendimai)
        error.addClass("feedback invalid-feedback");
        var existingFeedback = element.next(".feedback");
        var customPlacement = element.data('errorPlacement');
        var isTooltipster = element.data('tooltipstered');
        if (existingFeedback.length) {
            existingFeedback.replaceWith(error);
        } else if (customPlacement) {
            error.appendTo(customPlacement);
        } else if (isTooltipster) {
            element.tooltipster({
                content: error,
                side: isTooltipster || 'top'
            });
        } else {
            if (element.parent().hasClass('input-group')) {
                element.parent().after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.before(error);
            } else {
                element.after(error);
            }
        }
    },
    onkeyup: function (element) {
        this.element(element);
    }
});

$.validator.addMethod(
    'phonecheck',
    function (value, element) {
        value = value.replace(/\s/g, '');

        var validator = this,
            val = value.replace(/\D/g, ''), //  --> 37060112222
            prefix = val.slice(0, -7), // --> 3706, 86
            phone = val.slice(prefix.length); // --> 0112222

        if (prefix.charAt(1) !== '8' && prefix.substring(0, 3) !== '370') {
            return true; // 2018-02-07 Donatas - - jeigu prefix ne LT, tai nebevaliduojame
        }
        element.value = val.length > 0 ? value : '';

        // xbug taisyti
        var checkPhone = function () {
            if (
                phone.length === 7 &&
                (prefix.length === 4 || prefix.length === 2)
            ) {
                if (prefix.length === 2 && prefix.charAt(0) === '8') {
                    val = '370' + val.substr(1);
                }

                // val = val.replace(/(\d{3})(\d{3})(\d{5})/, '$1 $2 $3');
                val = val.replace(
                    /(\d{3})(\d{1})(\d{3})(\d{4})/,
                    '$1 $2 $3 $4'
                );

                element.value = '+' + val;

                return true;
            } else {
                return false;
            }
        };

        return validator.optional(element) || checkPhone();
    },
    'Leistini telefono numerio formatai: +370 657 58554, 8 (5) 5255544, 8 458 55552'
);

$.validator.addMethod(
    'ibancheck',
    function (value, element) {
        if (!value) return true;
        var CODE_LENGTHS = {
            AD: 24,
            AE: 23,
            AT: 20,
            AZ: 28,
            BA: 20,
            BE: 16,
            BG: 22,
            BH: 22,
            BR: 29,
            CH: 21,
            CR: 21,
            CY: 28,
            CZ: 24,
            DE: 22,
            DK: 18,
            DO: 28,
            EE: 20,
            ES: 24,
            FI: 18,
            FO: 18,
            FR: 27,
            GB: 22,
            GI: 23,
            GL: 18,
            GR: 27,
            GT: 28,
            HR: 21,
            HU: 28,
            IE: 22,
            IL: 23,
            IS: 26,
            IT: 27,
            JO: 30,
            KW: 30,
            KZ: 20,
            LB: 28,
            LI: 21,
            LT: 20,
            LU: 20,
            LV: 21,
            MC: 27,
            MD: 24,
            ME: 22,
            MK: 19,
            MR: 27,
            MT: 31,
            MU: 30,
            NL: 18,
            NO: 15,
            PK: 24,
            PL: 28,
            PS: 29,
            PT: 25,
            QA: 29,
            RO: 24,
            RS: 22,
            SA: 24,
            SE: 24,
            SI: 19,
            SK: 24,
            SM: 27,
            TN: 24,
            TR: 26
        };
        var iban = String(value)
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
            code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
            digits;
        // check syntax and length
        if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
            return false;
        }
        // rearrange country code and check digits, and convert chars to ints
        digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (
            letter
        ) {
            return letter.charCodeAt(0) - 55;
        });
        // final check
        if (mod97(digits) === false) return false;
        if (code[1] === 'LT')
            element.value = code[0].replace(
                /(LT)(\d{2})(\d{4})(\d{4})(\d{4})/,
                '$1 $2 $3 $4 $5 '
            );

        return true;

        /** Validaus IBAN algoritmas
         * @param {string} string
         * @return {boolean}
         */
        function mod97(string) {
            var checksum = string.slice(0, 2),
                fragment;
            for (var offset = 2; offset < string.length; offset += 7) {
                fragment =
                    String(checksum) + string.substring(offset, offset + 7);
                checksum = parseInt(fragment, 10) % 97;
            }
            if (checksum === 1) {
                return true;
            } else {
                return false;
            }
        }
    },
    'Netinkamas IBAN formatas.'
);

$.validator.addMethod(
    'xpersonalcode',
    function (value) {
        if (!value) {
            return true;
        } else if (
            isNaN(value) === true ||
            !xhelper.array.in_array(value.length, [7, 9, 11])
        ) {
            return false;
        }

        var letters = [],
            sumArray = [],
            sumRule = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3],
            sum = 0;
        for (var i = 0; i < 11; i++) {
            letters[i] = value.substring(i, i + 1);
            if (i < 9) {
                sumArray[i] = Number(letters[i]) * (i + 1);
            } else if (i === 9) {
                sumArray[i] = Number(letters[i]);
            }
        }

        if (!xhelper.array.in_array(sumArray[0], [3, 4, 5, 6])) {
            return false;
        } else {
            for (var j = 0; j < 10; j++) {
                sum += sumArray[j];
            }
        }

        sum = sum % 11;
        if (sum !== 10) {
            if (sum === Number(letters[10])) {
                return true;
            } else {
                return false;
            }
        } else if (sum === 10 && Number(letters[10] == 0)) {
            return true;
        } else if (sum === 10) {
            //xlog(letters);
            //xlog(sum);
            var suma = 0;

            for (var i = 0; i < 10; i++) {
                suma += sumRule[i] * Number(letters[i]);
            }

            if ((suma % 11) == letters[10]) {
                return true;
            }
        } else {
            return false;
        }
        // truksta 7 ir 9 skaitmenu ilgio AK validavimo
    },
    'Netinkamai įvestas asmens kodas.'
);

$.validator.addMethod('xcompanycode', function (value) {
    if (!value) {
        return true;
    } else if (isNaN(value) === true || value.length !== 9) {
        return false;
    }
    var numbers = [],
        sumArray = [],
        sum = 0;
    if (value.length === 9) {
        for (var i = 0; i < 9; i++) {
            numbers[i] = value.substring(i, i + 1);
            if (i < 8) {
                sumArray[i] = Number(numbers[i]) * (i + 1);
            } else if (i === 8) {
                sumArray[i] = Number(numbers[i]);
            }
        }
        for (var j = 0; j < 8; j++) {
            sum += sumArray[j];
        }
        console.log("sum=" + sum);
        sum = sum % 11;
        console.log("sum%11=" + sum);
        console.log("9th number=" + sumArray[8]);
        if (sum > 9) {
            return false
        } else {
            if (sum === sumArray[8]) {
                return true;
            } else {
                return false;
            }
        }
    }
},
    'Netinkamai įvestas įmonės kodas.'
);

$.validator.addMethod(
    'xdate',
    function (value, element, params) {
        var validator = this,
            date = moment(value),
            isValid = date.isValid(),
            type = element.dataset.type,
            min = element.dataset.mindate,
            max = element.dataset.maxdate,
            isTime = element.dataset.time || type != 'xdate',
            //format = isTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD',
            format = 'YYYY-MM-DD'
        err = '';

        var langs = {
            lt: {
                enter_valid_date: 'Įveskite korektišką datą',
                date_cant_be_after: 'Data negali būti vėliau',
                date_cant_be_before: 'Data negali būti anksčiau'
            },
            en: {
                enter_valid_date: 'Please enter a valid date',
                date_cant_be_after: 'Date can\'t be after',
                date_cant_be_before: 'Date can\'t be before'
            }
        },
            lang = langs[locale || 'lt'];

        if (isValid) {
            element.value = date.format(format);

            if (min && date.isBefore(min)) {
                err = lang.date_cant_be_before + ' ' + min;
            }
            if (max && date.isAfter(max)) {
                err = lang.date_cant_be_after + ' ' + max;
            }
        } else if (element.value) {
            err = lang.enter_valid_date;
        }

        if (err.length && element.value) {
            var errors = {};

            errors[element.name] = checkCustomValidationMessage({
                validator: validator,
                value: value,
                element: element,
                params: params
            },
                element,
                err
            );

            validator.showErrors(errors);
        }

        return validator.optional(element) || isValid;
    },
    'Įveskite korektišką datą'
);

$.validator.addMethod(
    'allow',
    function (value, element, params) {
        var validator = this,
            delimiter = ';',
            allow = element.dataset.allow; // < 2; > 2

        if (!allow || value === '') return validator.optional(element) || true;

        var r = {
            opers: /([<>=]+)/gi, // >, >=, <, <=, =, == ir t.t.
            white: /\s/g // white-space
        };

        var langs = {
            lt: {
                enter_valid_sum: 'Netinkamas skaičius',
                sum_has_to_be: 'Skaičius turi būti',
                delimiter: ' ir '
            },
            en: {
                enter_valid_sum: 'Invalid number',
                sum_has_to_be: 'Number has to be ',
                delimiter: ' and '
            }
        },
            lang = langs[locale || 'lt'];

        allow = allow.replace(r.white, '');
        allow = allow.split(delimiter); // -> ["<80", ">30"]
        allow = _.sortBy(allow).reverse(); // -> [">30", "<80"]

        var operations = {
            '<': function (a, b, el) {
                return a < b;
            },
            '>': function (a, b, el) {
                return a > b;
            },
            '>=': function (a, b, el) {
                el.value = a >= b ? el.value : b;
                return a >= b;
            },
            '<=': function (a, b, el) {
                return a <= b;
            },
            '=': function (a, b, el) {
                return a === b;
            }
        };

        var hasErrors = false;

        for (var i = 0; i < allow.length; i++) {
            var op = allow[i].match(r.opers)[0]; // >
            var number = allow[i].replace(r.opers, ''); // 10

            if (
                op &&
                !operations[op](parseFloat(value), parseFloat(number), element)
            ) {
                hasErrors = true;
                break;
            }
        }

        if (hasErrors === true) {
            var message = {};

            message[element.name] = checkCustomValidationMessage({
                validator: validator,
                value: value,
                element: element,
                params: params
            },
                element,
                lang.sum_has_to_be + ' ' + allow.join(lang.delimiter)
            );

            validator.showErrors(message);
            return false;
        }

        return true;
    },
    'Netinkama suma'
);

/**
 * Patikrina, ar elementas turi specialią netinkamo lauko žinutę. Jeigu taip, grąžina ją, kitu atveju - numatytą `defaultMessage`.
 * @param {object} validatorArgs - validator scope kintamieji
 * @param {string} element - įvesties elementas
 * @param {string} defaultMessage - numatyta žinutę, naudojama, jeigu nėra nustatyta speciali žinutė.
 * @return {string} validacijos žinutė
 */
function checkCustomValidationMessage(validatorArgs, element, defaultMessage) {
    var customMsg = element.getAttribute('data-validation-msg'),
        msg;

    if (!customMsg) return defaultMessage;

    if (typeof window[customMsg] === 'function') {
        msg = window[customMsg].call(undefined, validatorArgs, defaultMessage);
    } else if (customMsg) {
        msg = customMsg;
    }

    return msg;
}